import { RouterState, RedirectFunction, EnterHook } from 'react-router';

import {
  AppState,
  getTemplateSubtype,
  shouldSkipIndustryView,
  shouldSkipPricingView,
  shouldSkipTemplateView,
  shouldjumpToIndustryView,
} from '../redux/reducers';

export const APP_PATHS = {
  PRODUCT: '/',
  INDUSTRY: '/industry',
  TEMPLATE: '/template',
  PRICING: '/pricing',
  DOMAIN: '/domain',
};

export const APP_PATH_SEQUENCE = [
  APP_PATHS.PRODUCT,
  APP_PATHS.INDUSTRY,
  APP_PATHS.TEMPLATE,
  APP_PATHS.PRICING,
  APP_PATHS.DOMAIN,
];

function isValidAppPath(path: string): boolean {
  return APP_PATH_SEQUENCE.indexOf(path) > -1;
}

function destinationAtOrBefore(destinationPath: string, endPath: string): boolean {
  const index = APP_PATH_SEQUENCE.indexOf(destinationPath);
  const endIndex = APP_PATH_SEQUENCE.indexOf(endPath);
  if (index === -1) {
    throw new Error(`unknown app path ${destinationPath}`);
  }
  if (endIndex === -1) {
    throw new Error(`unknown app path ${endPath}`);
  }
  return index <= endIndex;
}

function isTemplateDataValid(state: AppState): boolean {
  return getTemplateSubtype(state) != null;
}

export function getAppPaths(state: AppState): string[] {
  const res = APP_PATH_SEQUENCE.reduce((paths: string[], path: string) => {
    if (shouldSkipIndustryView(state) && path === APP_PATHS.INDUSTRY) {
      return paths;
    }
    if (shouldSkipTemplateView(state) && path === APP_PATHS.TEMPLATE) {
      return paths;
    }
    if (shouldSkipPricingView(state) && path === APP_PATHS.PRICING) {
      return paths;
    }
    if (shouldjumpToIndustryView(state) && path === APP_PATHS.PRODUCT) {
      return paths;
    }
    return [...paths, path];
  }, []);
  return res;
}

export function getNextDestination(currentPath: string, state: AppState): string {
  const appPaths = getAppPaths(state);
  const nextIndex = appPaths.indexOf(currentPath) + 1;
  return appPaths[nextIndex];
}

export function getAllowedDestination(destinationPath: string, state: AppState): string {
  if (!isValidAppPath(destinationPath)) {
    return APP_PATHS.PRODUCT;
  }

  if (destinationAtOrBefore(destinationPath, APP_PATHS.TEMPLATE)) {
    return destinationPath;
  } else if (!isTemplateDataValid(state)) {
    return APP_PATHS.TEMPLATE;
  }

  return destinationPath;
}

export function fnChain(...args: Function[]): EnterHook {
  return function (nextState: RouterState, replace: RedirectFunction, done: () => void) {
    args.forEach(async function (fn: Function) {
      await fn.call(null, nextState, replace, done);
    });
  };
}
